import React, { useState } from 'react';
import _ from 'lodash';
import { Tooltip } from '@fiverr-private/fit';
import localStorage from '../../../../service/localStorage';

const getDisplayedStorage = (key) => (
    key && localStorage.get(key)
);

const setDisplayedStorage = (key, value) => (
    localStorage.set(key, value)
);

const ContainerComponent = ({ close, setClose, children }) => {
    setClose(close);

    return (
        <span onClick={(e) => e.stopPropagation()}>
            {children}
        </span>
    );
};

/**
 * This component extends FIT Tooltip
 *
 *  TODO: generify the component and move to ORCA
 * **/

const TooltipGuide = (
    {
        storageKey,
        times = 1,
        onClose = _.noop,
        content,
        children,
        ...rest
    }) => {
    const [displayedCount, setDisplayedCount] = useState(getDisplayedStorage(storageKey) || 0);
    const shouldDisplay = !!(displayedCount < times && storageKey);
    const updatedDisplayCount = displayedCount + 1;
    let closeTooltip = _.noop;

    setDisplayedStorage(storageKey, updatedDisplayCount);

    const onCloseTooltip = () => {
        setDisplayedCount(updatedDisplayCount);
        closeTooltip();
        onClose();
    };

    return (
        <Tooltip className="modalities-popup"
            content={
                <div className="popup-guide-wrapper"
                    onClick={(e) => e.stopPropagation()}>
                    <div className="popover-content">
                        {content}
                    </div>
                    <button onClick={onCloseTooltip}>&times;</button>
                </div>
            }
            preventCloseAction
            trigger="click"
            boxClassName="popover-box-content"
            openClassName="tooltip-open"
            defaultOpen={shouldDisplay}
            bindBodyClickListener={false}
            {...rest}>
            <ContainerComponent setClose={(close) => closeTooltip = close}>
                <span onClick={(e) => e.stopPropagation()}>
                    {children}
                </span>
            </ContainerComponent>
        </Tooltip>
    );
};

export default TooltipGuide;
